// Los comprobantes de un pedido (decisión D57): factura, nota de venta, notas de crédito y remisión, para verlos y
// descargarlos. Solo si la distribuidora da la copia en la tienda.
import type { ComprobanteImprimible } from '@reparto/shared/nucleo';
import { api } from './api';

export interface ComprobanteTienda extends ComprobanteImprimible {
  total: number;
  pedido_venta_id: string | null;
}

export interface ComprobantesPedido {
  habilitado: boolean;
  formato?: 'ticket' | 'a4' | 'ambos';
  datos: ComprobanteTienda[];
}

export const comprobantesDelPedido = (pedidoId: string) =>
  api<ComprobantesPedido>(`/tienda/pedidos/${pedidoId}/comprobantes`);

/** El XML firmado de la factura electrónica (decisión D58), para guardarlo junto con el KuDE. */
export const xmlDelComprobante = (pedidoId: string, comprobanteId: string) =>
  api<string>(`/tienda/pedidos/${pedidoId}/comprobantes/${comprobanteId}/xml`, { texto: true });

/** Guarda el XML en el dispositivo con el CDC como nombre. */
export function guardarXml(xml: string, cdc: string): void {
  const url = URL.createObjectURL(new Blob([xml], { type: 'application/xml' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${cdc}.xml`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** "Factura 001-001-0000007" o "Factura (todavía sin número)". */
export function nombreDocumento(c: Pick<ComprobanteImprimible, 'tipo' | 'numero_visible'>, etiqueta: string): string {
  return `${etiqueta} ${c.numero_visible ?? '(todavía sin número)'}`;
}
